<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div class="ufv-container-text">
            <div class="text-h4">
                Área Administrativa: Usuários Institucionais
            </div>
        </div>
        <div
            v-if="loading"
            class="my-8 align-self-stretch d-flex align-center justify-center"
        >
            <spinner />
        </div>
        <div
            v-if="!loading"
            class="my-6 flex-grow-1"
            style="border: 0px solid red"
        >
            <div class="d-flex justify-space-between align-center">
                <router-link :to="{ name: 'NovoUsuarioInstitucional' }">
                    <v-btn color="primary"
                        ><v-icon>mdi-account-tag</v-icon
                        ><span class="pl-2"
                            >Novo Usuário Institucional</span
                        ></v-btn
                    >
                </router-link>
            </div>
            <h2 class="ma-8 text-center" v-if="usuarios.length == 0">
                Ainda não há nenhum usuário institucional cadastrado
            </h2>
            <div v-if="usuarios.length > 0" class="mt-4">
                <v-simple-table dense fixed-header>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Membros</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="usuario in usuarios" :key="usuario.id">
                            <td>
                                <router-link
                                    :to="{
                                        name: 'EditarUsuarioInstitucional',
                                        params: { id: usuario.id },
                                    }"
                                    >{{ usuario.id }}</router-link
                                >
                            </td>
                            <td>{{ usuario.nome }}</td>
                            <td>{{ usuario.email }}</td>
                            <td>{{ usuario.quantidadeUsuariosVinculados }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
        </div>
    </v-container>
</template>

<script>
import Spinner from "../../../componentes/ui/Spinner";
import { getServicoUsuarioInstitucional } from "../../../services/ServicosFactory";

const servicoUsuarioInstitucional = getServicoUsuarioInstitucional();

export default {
    name: "UsuarioInstitucionalAdmin",
    components: { Spinner },
    data() {
        return {
            usuarios: {},
            loading: true,
        };
    },
    mounted() {
        servicoUsuarioInstitucional
            .obterUsuariosInstitucionais()
            .then((usuarios) => {
                this.usuarios = usuarios;
            })
            .catch((err) => {
                console.log(err);
                this.$router.push({ name: "500" });
            })
            .finally(() => {
                this.loading = false;
            });
    },
};
</script>
